<script lang="ts" setup>
import { AppLink } from '@sunlabde/m2m-library';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import TopbarLanguageMenu from './TopbarLanguageMenu.vue';
import { useSignupNavigation } from '@/utilities/Navigation';
import { useStaticLinkComposer } from '@/utilities/StaticLinks';
import { useMainStore } from '@/store/main';

const { navigation: signupNavigationItems } = useSignupNavigation();
const staticLinkComposer = useStaticLinkComposer();

const { signupStyle } = storeToRefs(useMainStore());
const isThomannStyled = computed(() => signupStyle.value === 'thomann');
</script>

<template>
	<div class="w-screen widescreen:w-full fixed bg-white z-100">
		<div class="flex justify-between items-center px-6 z-100 relative border-b py-2 tablet:py-4">
			<div class="flex">
				<a
					:href="staticLinkComposer.compose('home')"
					class="w-8 mobile:w-28"
				>
					<img
						class="block mobile:hidden h-8"
						src="@/assets/logo-signet.svg"
						alt="logo"
					>
					<img
						class="hidden mobile:block h-8 tablet:h-10"
						src="@/assets/logo-dark.svg"
						alt="logo"
					>
				</a>
				<a
					v-if="isThomannStyled"
					class="border-l pl-4 ml-4 flex items-center w-24 mobile:w-32"
					href="https://www.thomann.de"
					rel="noopener noreferrer"
					target="_blank"
				>
					<img
						src="@/assets/thomann-cyan-black.svg"
						height="30"
						alt="thomann"
					>
				</a>
			</div>
			<slot />
			<div class="flex items-center space-x-2 relative z-50">
				<TopbarLanguageMenu />
				<div class="items-center hidden widescreen:flex space-x-2">
					<AppLink
						v-for="item in signupNavigationItems"
						:key="item.name"
						:link="String(item.link)"
						class="text-gray-700 hover:text-primary-400"
						target="_blank"
					>
						{{ item.name }}
					</AppLink>
				</div>
			</div>
		</div>
	</div>
</template>
